import { onBeforeMount } from 'vue'

export default {
    name: 'BreadCrumb',
    setup() {
        onBeforeMount(() => {
            document.documentElement.classList.add('kb-has-breadcrumb')
        })
    }
}
